import { Option } from '@univacity/shared/types';
import { StringUtil } from './string-util';

export class ObjectUtil {
  public static removeEmptyProperties(
    obj: Record<string, any>,
    keys: string[] = [],
    removeNestedProperty = true
  ) {
    const objClone = JSON.parse(JSON.stringify(obj));
    keys = keys.length > 0 ? keys : Object.keys(objClone);
    for (const k of keys) {
      if (Array.isArray(objClone[k])) {
        objClone[k] = objClone[k].map((v) =>
          ObjectUtil.removeEmptyProperties(v)
        );
      }
      const value = objClone[k];
      if (!(value || value === 0 || value === false) || value === '')
        delete objClone[k];
      if (typeof objClone[k] === 'object') {
        if (removeNestedProperty)
          objClone[k] = ObjectUtil.removeEmptyProperties(
            objClone[k],
            Object.keys(objClone[k])
          );
        if (JSON.stringify(objClone[k]) === JSON.stringify({}))
          delete objClone[k];
      }
    }
    return objClone;
  }
  public static emptyPropertyToNull(
    obj: Record<string, any>,
    keys: string[] = []
  ) {
    const objClone = JSON.parse(JSON.stringify(obj));
    keys = keys.length > 0 ? keys : Object.keys(objClone);
    for (const k of keys) {
      if (Array.isArray(objClone[k])) continue;
      const value = objClone[k];
      if (!(value || value === 0 || value === false) || value === '')
        objClone[k] = null;
    }
    return objClone;
  }

  static enumToKeyLabelValuePair(obj: object): Option[] {
    const options = Object.values(obj).map((o) => ({
      label: StringUtil.toTitleCase(o),
      value: o,
    }));
    return options;
  }
}
